import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SiShopware } from 'react-icons/si';
import { MdOutlineCancel } from 'react-icons/md'
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { links } from '../../assets/FakeData';
import { useStateContext } from '../../contexts';

const SideBar = () => {
  const { state, dispatch } = useStateContext()
  const { activeMenu, screenSize } = state
  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-black text-md m-2 bg-main-bg';
  const inactiveLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';
  const handleSideBar = () => {
    if (activeMenu && screenSize <= 900) {
      dispatch({ type: "setActiveMenu", payload: false })
    }
    dispatch({ type: "showDropDown", payload: "" })
  };
  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu
        &&
        (
          <>
            <div className="flex justify-between items-center">
              <Link to="/" className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-right dark:text-white text-slate-900">
                <SiShopware />
                <span>HosPiD</span>
              </Link>
              <TooltipComponent content="Menu" position="BottomCenter">
                <button type="button" onClick={() => { handleSideBar() }} className="text-2xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"><MdOutlineCancel /></button>
              </TooltipComponent>
            </div>
            {links.map((item) => (
              <div className="text-gray-400 m-3 mt-4 uppercase" key={item.title}>
                <p className="text-gray-400 m-3 mt-4 uppercase">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.name}`}
                    key={link.name}
                    onClick={() => { handleSideBar() }}
                    // style={({ isActive }) => ({ backgroundColor: isActive ? '#F7F7F7' : '' })}
                    className={({ isActive }) => isActive ? activeLink : inactiveLink}>
                    {link.icon}
                    <span className="capitalize">
                      {link.name}
                    </span>
                  </NavLink>
                ))}
              </div>
            ))}
          </>
        )
      }
    </div>
  );
};

export { SideBar };
